import { authClient } from './client';
import extractErrorMessage from '../utils/extractErrorMessage';

const categoryApi = {
  getAll: async (isDeleted) => {
    try {
      const params = {};
      if (isDeleted !== undefined) params.isDeleted = isDeleted;
      return (await authClient.get('/categories/database', { params })).data;
    } catch (error) {
      return { data: null, success: false, message: extractErrorMessage(error, 'Došlo je do greške pri dobavljanju kategorija.') };
    }
  },

  getById: async (id) => {
    try {
      return (await authClient.get(`/categories/${id}`)).data;
    } catch (error) {
      return { data: null, success: false, message: extractErrorMessage(error, 'Došlo je do greške pri dobavljanju kategorije.') };
    }
  },

  create: async (payload) => {
    try {
      return (await authClient.post('/categories', payload)).data;
    } catch (error) {
      return { data: null, success: false, message: extractErrorMessage(error, 'Došlo je do greške pri kreiranju kategorije.') };
    }
  },

  update: async (id, payload) => {
    try {
      return (await authClient.put(`/categories/${id}`, payload)).data;
    } catch (error) {
      return { data: null, success: false, message: extractErrorMessage(error, 'Došlo je do greške pri izmeni kategorije.') };
    }
  },

  hide: async (id) => {
    try {
      return (await authClient.delete(`/categories/${id}`)).data;
    } catch (error) {
      return { data: null, success: false, message: extractErrorMessage(error, 'Došlo je do greške pri sakrivanju kategorije.') };
    }
  },

  restore: async (id) => {
    try {
      return (await authClient.patch(`/categories/${id}/restore`)).data;
    } catch (error) {
      return { data: null, success: false, message: extractErrorMessage(error, 'Došlo je do greške pri vraćanju kategorije.') };
    }
  },
};

export default categoryApi;
